module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-UltraBoldItalic.c5336f8.woff";